export const Roles = {
    ADMIN: "Admin",
    CREATOR: "Creator",
    OWNER: "Owner",
    EDITOR: "Editor",
    VIEWER: "Viewer",
  };